
// src/plugins/vuetify.js
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify);
export default new Vuetify({
    iconfont: "mdi", // 'md' || 'mdi' || 'fa' || 'fa4'
    theme: {
        themes:{
            light: {
                primary: '#004F85',
                secondary: '#b0bec5',
                accent: '#101020',
                error: '#b71c1c',
                background: '#f8f8f8'
            },
        }
    },
});
